import { createBrowserRouter, type RouteObject } from 'react-router-dom';
import { ServiceShell } from '@/app/layout/service-shell';
import { Coupon } from '@/pages/coupon/coupon';
import { NotFound } from '@/pages/not-found/not-found';
import type { RouteHandle } from '@/shared/lib/use-page-title';

export const routes: RouteObject[] = [
  {
    element: <ServiceShell />,
    children: [
      { path: '/:code', element: <Coupon />, handle: { title: '쿠폰 확인' } satisfies RouteHandle },
      { path: '*', element: <NotFound />, handle: { title: '페이지를 찾을 수 없어요' } satisfies RouteHandle },
    ],
  },
];

export const router = createBrowserRouter(routes);
